import React from 'react'
import moment from 'moment'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'
import { useCallback, useMemo } from 'sb-hooks'

import UserInfo from '../UserInfo/UserInfo'
import ActionButtons from '../ActionButtons/ActionButtons'

import messages from './messages'
import s from './Reply.scss'


export type ReplyProps = {
  reply: {
    id: number
    text: string
    date: string
    likeCount: number
    dislikeCount: number
    isUseful: boolean | null
    helpful: {
      positive: number
      negative: number
      isUseful: boolean | null
    }
    user: {
      id: number
      firstName: string
      lastName: string
      gender: Gender
      avatar?: string
      url: string
    }
  },
  reviewId: number
  currentUserId: number
  onVote: (data: {
    isUseful: boolean | null
    replyId: number
    reviewId: number
  }) => void
}


const Reply: React.FunctionComponent<ReplyProps> = (props) => {
  const { reply, reviewId, currentUserId, onVote } = props
  const { id, user, user: { id: authorId }, date, text, isUseful, likeCount, dislikeCount } = reply

  const handleVote = useCallback(({ isUseful }) => {
    const initialIsUseful = reply.isUseful

    if (initialIsUseful === isUseful) {
      isUseful = null
    }

    if (typeof onVote === 'function') {
      onVote({ isUseful, replyId: reply.id, reviewId })
    }
  }, [ onVote ])

  const formattedDate = useMemo(() => moment(date).format('MM/DD/YYYY'), [ date ])

  return (
    <div className={s.reply}>
      <div className={s.header}>
        <UserInfo avatarClassName={s.replyAvatar} {...user} />
        <div className={s.date}>
          {formattedDate}
        </div>
      </div>
      <div className={s.body}>
        <div className={s.text} data-testid="replyMessage">
          {text}
        </div>
        {
          currentUserId !== authorId && (
            <div className={s.helpful}>
              <div className={s.helpfulText}>
                <FormattedMessage {...messages.helpful} />
              </div>
              <ActionButtons
                id={id}
                isUseful={isUseful}
                likeCount={likeCount}
                dislikeCount={dislikeCount}
                onVote={handleVote}
                dataTestIds={{
                  likeButton: constants.testIds.reply.likeButton,
                  dislikeButton: constants.testIds.reply.dislikeButton,
                }}
              />
            </div>
          )
        }
      </div>
    </div>
  )
}


export default Reply
